export const adminLocaleCookie = "admin_locale";
export const defaultLocale = "cs";
export const locales = ["cs", "en"] as const;

export type AdminLocale = (typeof locales)[number];

export function isAdminLocale(locale: unknown): locale is AdminLocale {
  return typeof locale === "string" && locales.includes(locale as AdminLocale);
}

export function resolveAdminLocale(locale: unknown): AdminLocale {
  return isAdminLocale(locale) ? locale : defaultLocale;
}
